/**
 * Build a PATCH body that matches hms/kot-configuration validator.
 */
function pickRelationId(rawId, nested) {
  if (rawId != null && rawId !== '') {
    const n = Number(rawId);
    return Number.isFinite(n) ? n : null;
  }
  if (nested && nested.id != null) {
    const n = Number(nested.id);
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

function toBoolean(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

function toOptionalPx(value) {
  if (value === '' || value === null || value === undefined) return null;
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(n);
}

function expandShortHex(hex) {
  const h = hex.replace('#', '');
  if (h.length === 3) {
    return `#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`;
  }
  return hex.startsWith('#') ? hex : `#${h}`;
}

/** Normalize theme color from picker (hex, short hex, or rgba fallback). */
export function normalizeThemePrimaryColor(color) {
  const fallback = '#512d82';
  if (!color || typeof color !== 'string') return fallback;
  const s = color.trim();
  if (!s) return fallback;
  if (/^rgba?\(/i.test(s)) return fallback;
  if (s.startsWith('#')) {
    const body = s.slice(1);
    if (/^[0-9A-Fa-f]{3}$/.test(body)) return expandShortHex(s);
    if (/^[0-9A-Fa-f]{6}$/i.test(body)) return `#${body.slice(0, 6)}`;
  }
  if (/^[0-9A-Fa-f]{3}$/i.test(s)) return expandShortHex(`#${s}`);
  if (/^[0-9A-Fa-f]{6}$/i.test(s)) return `#${s}`;
  return fallback;
}

export function buildKotConfigurationPatchBody(kot) {
  const source = kot || {};
  const serviceCharge = Number(source.service_charge);

  return {
    guest_id: pickRelationId(source.guest_id, source.guest),
    kitchen_id: pickRelationId(source.kitchen_id, source.kitchen),
    waiter_id: pickRelationId(source.waiter_id, source.waiter),
    place_id: pickRelationId(source.place_id, source.place),
    kot_url: String(source.kot_url || '').trim(),
    display_time: toBoolean(source.display_time),
    on_screen_keyboard: toBoolean(source.on_screen_keyboard),
    display_customer_details_on_receipt: toBoolean(
      source.display_customer_details_on_receipt,
    ),
    service_charge: Number.isFinite(serviceCharge) ? serviceCharge : 0,
    calendar_day_col_px: toOptionalPx(source.calendar_day_col_px),
    calendar_row_height_px: toOptionalPx(source.calendar_row_height_px),
    calendar_header_height_px: toOptionalPx(source.calendar_header_height_px),
    calendar_text_align: source.calendar_text_align || 'left',
    calendar_show_time:
      source.calendar_show_time === undefined || source.calendar_show_time === null
        ? true
        : toBoolean(source.calendar_show_time),
    theme_primary_color: normalizeThemePrimaryColor(source.theme_primary_color),
    pwa_enabled: toBoolean(source.pwa_enabled),
  };
}
